"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.function.name");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.promise");

var _storage = _interopRequireDefault(require("./storage"));

var _isIE = _interopRequireDefault(require("./isIE"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

// 默认的数据库名
var DB_NAME = 'kepler';

var LocalStore =
/*#__PURE__*/
function () {
  function LocalStore(name) {
    var _this = this;

    _classCallCheck(this, LocalStore);

    // 存储实例
    this.store = null; // 是否是IndexDB

    this.isDB = true; // 新建的表名

    this.name = name; // 键名

    this.keyPath = 'event_id'; // 添加数据和获取所有数据操作执行队列

    this.todoAddData = [];
    this.todoGetAll = []; // 创建数据库和表

    this.createDB().then(function () {
      return _this.createTable();
    });
  } // 创建数据库


  _createClass(LocalStore, [{
    key: "createDB",
    value: function createDB() {
      var _this2 = this;

      return new Promise(function (resolve) {
        var db = window.indexedDB || window.webkitIndexedDB || window.mozIndexedDB || window.msIndexedDB; // Partial support in IE 10 & 11 refers to a number of subfeatures not being supported.

        if ((0, _isIE.default)() || !db) {
          _this2.degrade();

          resolve();
          return;
        } // 创建数据库


        var request = db.open(DB_NAME); // 创建数据库成功
        // 首次创建数据会先触发onupgradeneeded，然后触发onsuccess
        // 已经存在数据库只触发onsuccess
        // https://www.kancloud.cn/dennis/tgjavascript/241831

        request.onsuccess = function (event) {
          _this2.isDB = true;
          _this2.store = event.target.result; // 因为异步创建数据库 导致数据库增加和查询操作只能插入等待队列等待创建数据库成功后处理

          _this2.todoAddData.forEach(function (fn) {
            return fn();
          });

          _this2.todoGetAll.forEach(function (fn) {
            return fn();
          }); // 销毁队列


          _this2.todoAddData = null;
          _this2.todoGetAll = null;
        }; // 创建表。不能在onsuccess回调创建 针对首次创建数据库触发
        // https://blog.csdn.net/qiqingjin/article/details/53263261


        request.onupgradeneeded = function (event) {
          _this2.isDB = true;
          _this2.store = event.target.result;
          resolve();
        }; // 创建数据库失败


        request.onerror = function () {
          _this2.degrade();

          resolve();
        };
      });
    } // 新建表

  }, {
    key: "createTable",
    value: function createTable() {
      var name = this.name;

      if (this.isDB) {
        // 检查是否有该表存在
        if (!this.store.objectStoreNames.contains(name)) {
          this.store.createObjectStore(name, {
            keyPath: this.keyPath
          });
        }
      } else {
        this.store.setItem(name, []);
      }
    } // 降级使用localStorage

  }, {
    key: "degrade",
    value: function degrade() {
      this.isDB = false;
      this.store = _storage.default;
    } // IndexDB创建表是一个异步过程，当出现代码阻塞时
    // 会出现执行addData时 出现报错异常 因为还没执行createTable
    // 所以通过队列维护 等createTable执行成功后执行队列

  }, {
    key: "wrap",
    value: function wrap(fn, queue) {
      return this.store ? fn() : queue.push(fn);
    } // 新增一条数据

  }, {
    key: "addData",
    value: function addData(data) {
      var _this3 = this;

      // eslint-disable-next-line
      return new Promise(function (resolve, reject) {
        var name = _this3.name;

        if (_this3.isDB) {
          _this3.wrap(function () {
            var objectStore = _this3.store.transaction([name], 'readwrite').objectStore(name);

            var addReq = objectStore.add(data);
            addReq.onerror = reject;

            addReq.onsuccess = function () {
              // 返回添加成功后记录总数
              objectStore.count().onsuccess = function (event) {
                resolve(event.target.result);
              };
            };
          }, _this3.todoAddData);
        } else {
          var allLastData = _this3.store.getItem(name);

          var allNextData = _toConsumableArray(allLastData).concat([data]);

          try {
            _this3.store.setItem(name, allNextData);

            return resolve();
          } catch (error) {
            return reject(error);
          }
        }
      });
    } // http://javascript.ruanyifeng.com/bom/indexeddb.html#toc7
    // getAll方法在IE中没有实现

  }, {
    key: "enhancedGetAll",
    value: function enhancedGetAll() {
      var name = this.name;
      var objectStore = this.store.transaction([name], 'readonly').objectStore(name);
      var getAll = objectStore.getAll;
      if (getAll) return getAll.apply(objectStore);
      var data = [];
      var openCursor = {};

      objectStore.openCursor().onsuccess = function (event) {
        var cursor = event.target.result;

        if (cursor) {
          data.push(cursor.value);
          cursor.continue();
        } else {
          var _event = {
            target: {
              result: data
            }
          };
          openCursor.onsuccess(_event);
          data = null;
          _event = null;
        }
      };

      return openCursor;
    } // 获取所有数据数据

  }, {
    key: "getAll",
    value: function getAll() {
      var _this4 = this;

      return new Promise(function (resolve) {
        var name = _this4.name;

        if (_this4.isDB) {
          _this4.wrap(function () {
            var request = _this4.enhancedGetAll();

            request.onsuccess = function (event) {
              resolve(event.target.result);
            };
          }, _this4.todoGetAll);
        } else {
          resolve(_this4.store.getItem(name));
        }
      });
    } // 删除数据
    // 上报成功之后删除本地数据

  }, {
    key: "delData",
    value: function delData(data) {
      var name = this.name;
      var keyPath = this.keyPath;
      var keys = data.map(function (item) {
        return item[keyPath];
      });

      if (this.isDB) {
        var objectStore = this.store.transaction([name], 'readwrite').objectStore(name);
        keys.forEach(function (key) {
          return objectStore.delete(key);
        });
      } else {
        var unReportedData = this.store.getItem(name).filter(function (item) {
          return !keys.includes(item[keyPath]);
        });
        this.store.setItem(name, unReportedData);
      }
    }
  }]);

  return LocalStore;
}();

var _default = LocalStore;
exports.default = _default;